// Страницы сайта для поисковиков: адрес, заголовки и описания на трёх языках.
// Русский — без приставки (/iphone), узбекский — /uz/iphone, каракалпакский — /kaa/iphone.
import { useEffect } from "react";

export const SITE = "https://telestorenukus.uz";
export const LANG_CODES = ["ru", "uz", "kaa"];

// key → адрес и что показывать. brand — какие телефоны в каталоге, sec — к какому блоку главной прокрутить
export const PAGES = {
    home: { path: "" },
    catalog: { path: "catalog", view: "catalog" },
    iphone: { path: "iphone", view: "catalog", brand: /iphone|apple/i },
    samsung: { path: "samsung", view: "catalog", brand: /samsung|galaxy/i },
    xiaomi: { path: "xiaomi", view: "catalog", brand: /xiaomi|redmi|poco/i },
    credit: { path: "rassrochka", sec: "credit" },
    contacts: { path: "kontakty", sec: "contacts" },
};

export const prefix = (lang) => (lang === "ru" ? "" : "/" + lang);
export const pageUrl = (lang, key) => {
    const p = PAGES[key]?.path ?? "";
    return prefix(lang) + "/" + p;
};

// Разбор адреса: /uz/iphone → { lang: "uz", key: "iphone" }
export const parsePath = (pathname) => {
    const parts = pathname.split("/").filter(Boolean);
    let lang = "ru";
    if (parts[0] === "uz" || parts[0] === "kaa") lang = parts.shift();
    const rest = parts.join("/");
    const key = Object.keys(PAGES).find((k) => PAGES[k].path === rest);
    return { lang, key: key || null };
};

const ADDR = { ru: "Дихан базар, магазин №9", uz: "Dehqon bozori, 9-do‘kon", kaa: "Diyxan bazari, 9-dukan" };

// title — вкладка и заголовок в поиске, desc — текст под ним, h1 — заголовок на самой странице
export const SEO = {
    ru: {
        home: { title: "TELE STORE — телефоны в Нукусе, рассрочка", h1: "Телефоны в Нукусе по честной цене",
            desc: `Телефоны в наличии в Нукусе: iPhone, Samsung, Xiaomi. Проверка IMEI, рассрочка без банка. ${ADDR.ru}.` },
        catalog: { title: "Каталог телефонов — TELE STORE Нукус", h1: "Каталог телефонов в наличии",
            desc: "Все телефоны в наличии с ценой и платежом в месяц. iPhone, Samsung, Xiaomi в Нукусе." },
        iphone: { title: "Купить iPhone в Нукусе — TELE STORE", h1: "iPhone в Нукусе — в наличии и в рассрочку",
            desc: "iPhone в наличии в Нукусе: цены, память, состояние батареи. Рассрочка без банка, проверка IMEI." },
        samsung: { title: "Купить Samsung в Нукусе — TELE STORE", h1: "Samsung в Нукусе",
            desc: "Телефоны Samsung Galaxy в наличии в Нукусе. Рассрочка без банка, проверка IMEI." },
        xiaomi: { title: "Купить Xiaomi, Redmi в Нукусе — TELE STORE", h1: "Xiaomi и Redmi в Нукусе",
            desc: "Xiaomi, Redmi и Poco в наличии в Нукусе. Доступные цены и рассрочка." },
        credit: { title: "Телефон в рассрочку в Нукусе — TELE STORE", h1: "Телефон в рассрочку в Нукусе",
            desc: "Рассрочка на телефон без банка. Посчитайте платёж в месяц онлайн и приходите в магазин." },
        contacts: { title: "Контакты — TELE STORE Нукус", h1: "Магазин телефонов TELE STORE — Дихан базар",
            desc: `г. Нукус, ${ADDR.ru}. Телефон +998 77 116 70 00. Работаем с 9:00 до 20:00.` },
    },
    uz: {
        home: { title: "TELE STORE — Nukusda telefonlar, muddatli to‘lov", h1: "Nukusda telefonlar — halol narxda",
            desc: `Nukusda mavjud telefonlar: iPhone, Samsung, Xiaomi. IMEI tekshiruvi, banksiz muddatli to‘lov. ${ADDR.uz}.` },
        catalog: { title: "Telefonlar katalogi — TELE STORE Nukus", h1: "Mavjud telefonlar katalogi",
            desc: "Mavjud barcha telefonlar narxi va oylik to‘lovi bilan. Nukusda iPhone, Samsung, Xiaomi." },
        iphone: { title: "Nukusda iPhone sotib olish — TELE STORE", h1: "Nukusda iPhone — mavjud va muddatli to‘lovga",
            desc: "Nukusda mavjud iPhone: narxlar, xotira, batareya holati. Banksiz muddatli to‘lov, IMEI tekshiruvi." },
        samsung: { title: "Nukusda Samsung sotib olish — TELE STORE", h1: "Nukusda Samsung",
            desc: "Nukusda mavjud Samsung Galaxy telefonlari. Banksiz muddatli to‘lov, IMEI tekshiruvi." },
        xiaomi: { title: "Nukusda Xiaomi, Redmi sotib olish — TELE STORE", h1: "Nukusda Xiaomi va Redmi",
            desc: "Nukusda mavjud Xiaomi, Redmi va Poco. Qulay narxlar va muddatli to‘lov." },
        credit: { title: "Nukusda telefon muddatli to‘lovga — TELE STORE", h1: "Nukusda telefon muddatli to‘lovga",
            desc: "Telefonga banksiz muddatli to‘lov. Oylik to‘lovni onlayn hisoblang va do‘konga keling." },
        contacts: { title: "Aloqa — TELE STORE Nukus", h1: "TELE STORE telefon do‘koni — Dehqon bozori",
            desc: `Nukus sh., ${ADDR.uz}. Telefon +998 77 116 70 00. Ish vaqti 9:00–20:00.` },
    },
    kaa: {
        home: { title: "TELE STORE — Nokiste telefonlar, bolip tolew", h1: "Nokiste telefonlar — adil bahada",
            desc: `Nokiste bar telefonlar: iPhone, Samsung, Xiaomi. IMEI tekseriw, banksiz bolip tolew. ${ADDR.kaa}.` },
        catalog: { title: "Telefonlar katalogi — TELE STORE Nokis", h1: "Bar telefonlar katalogi",
            desc: "Bar barliq telefonlar bahasi ham ayliq tolemi menen. Nokiste iPhone, Samsung, Xiaomi." },
        iphone: { title: "Nokiste iPhone satip aliw — TELE STORE", h1: "Nokiste iPhone — bar ham bolip tolewge",
            desc: "Nokiste bar iPhone: bahalar, yad, batareya jag‘dayi. Banksiz bolip tolew, IMEI tekseriw." },
        samsung: { title: "Nokiste Samsung satip aliw — TELE STORE", h1: "Nokiste Samsung",
            desc: "Nokiste bar Samsung Galaxy telefonlari. Banksiz bolip tolew, IMEI tekseriw." },
        xiaomi: { title: "Nokiste Xiaomi, Redmi satip aliw — TELE STORE", h1: "Nokiste Xiaomi ham Redmi",
            desc: "Nokiste bar Xiaomi, Redmi ham Poco. Qolayli bahalar ham bolip tolew." },
        credit: { title: "Nokiste telefon bolip tolewge — TELE STORE", h1: "Nokiste telefon bolip tolewge",
            desc: "Telefong‘a banksiz bolip tolew. Ayliq tolemdi onlayn esaplan ham dukang‘a kelin." },
        contacts: { title: "Baylanis — TELE STORE Nokis", h1: "TELE STORE telefon dukani — Diyxan bazari",
            desc: `Nokis q., ${ADDR.kaa}. Telefon +998 77 116 70 00. Jumis waqti 9:00–20:00.` },
    },
};

export const seoText = (lang, key) => SEO[lang]?.[key] || SEO.ru[key] || SEO.ru.home;

// Теги в <head>: title, description, canonical, og, hreflang
const setMeta = (attr, name, content) => {
    let el = document.head.querySelector(`meta[${attr}="${name}"]`);
    if (!el) { el = document.createElement("meta"); el.setAttribute(attr, name); document.head.appendChild(el); }
    el.setAttribute("content", content);
};
const setLink = (rel, href, hreflang) => {
    const sel = hreflang ? `link[rel="${rel}"][hreflang="${hreflang}"]` : `link[rel="${rel}"]:not([hreflang])`;
    let el = document.head.querySelector(sel);
    if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); if (hreflang) el.setAttribute("hreflang", hreflang); document.head.appendChild(el); }
    el.setAttribute("href", href);
};
const OG_LOCALE = { ru: "ru_RU", uz: "uz_UZ", kaa: "kaa_UZ" };

export const useSeo = (lang, key) => {
    useEffect(() => {
        const s = seoText(lang, key);
        const url = SITE + pageUrl(lang, key);
        document.title = s.title;
        document.documentElement.lang = lang;
        setMeta("name", "description", s.desc);
        setLink("canonical", url);
        setMeta("property", "og:type", "website");
        setMeta("property", "og:site_name", "TELE STORE");
        setMeta("property", "og:title", s.title);
        setMeta("property", "og:description", s.desc);
        setMeta("property", "og:url", url);
        setMeta("property", "og:image", SITE + "/logo.png");
        setMeta("property", "og:locale", OG_LOCALE[lang]);
        // У каракалпакского нет двухбуквенного кода, Google его в hreflang не понимает — связываем ru и uz
        setLink("alternate", SITE + pageUrl("ru", key), "ru");
        setLink("alternate", SITE + pageUrl("uz", key), "uz");
        setLink("alternate", SITE + pageUrl("ru", key), "x-default");
    }, [lang, key]);
};
